import { AppDashboardSplitType } from '../../../../types/generated';

const today = new Date();

const lastSevenDays = new Date(today);
lastSevenDays.setDate(today.getDate() - 7);

const lastThirty = new Date(today);
lastThirty.setDate(today.getDate() - 30);

const lastThreeMonths = new Date(today);
lastThreeMonths.setMonth(today.getMonth() - 3);

const lastSixMonths = new Date(today);
lastSixMonths.setMonth(today.getMonth() - 6);

const lastYear = new Date(today);
lastYear.setFullYear(today.getFullYear() - 1);

export const Options = [
    {
        value: 7,
        label: 'Last 7 days',
        availableSplitTypes: [AppDashboardSplitType.Daily],
        from: lastSevenDays,
    },
    {
        value: 30,
        label: 'Last 30 days',
        availableSplitTypes: [AppDashboardSplitType.Daily, AppDashboardSplitType.Weekly],
        from: lastThirty,
    },
    {
        value: 93,
        label: 'Last 3 months',
        availableSplitTypes: [
            AppDashboardSplitType.Monthly,
            AppDashboardSplitType.Daily,
            AppDashboardSplitType.Weekly,
        ],
        from: lastThreeMonths,
    },
    {
        value: 182,
        label: 'Last 6 months',
        availableSplitTypes: [
            AppDashboardSplitType.Monthly,
            AppDashboardSplitType.Daily,
            AppDashboardSplitType.Weekly,
        ],
        from: lastSixMonths,
    },
    {
        value: 365,
        label: 'Last year',
        availableSplitTypes: [
            AppDashboardSplitType.Monthly,
            AppDashboardSplitType.Daily,
            AppDashboardSplitType.Weekly,
        ],
        from: lastYear,
    },
];
